import { Flex, Grid, Text } from "@chakra-ui/react";
import { storyblokEditable } from "@storyblok/react";
import Link from "next/link";
import { useState } from "react";

const alphabet = [
  "a",
  "b",
  "c",
  "d",
  "e",
  "f",
  "g",
  "h",
  "i",
  "j",
  "k",
  "l",
  "m",
  "n",
  "o",
  "p",
  "q",
  "r",
  "s",
  "t",
  "u",
  "v",
  "w",
  "x",
  "y",
  "z",
];

const gridCountLimit = 15;

const WhatsWorryingYouBlok = ({ blok }) => {
  const { worries, letterHasItems } = blok;
  const [filterBy, setFilterBy] = useState(null);

  return (
    <Flex
      mx={[5, blok.pageMargins && "10%"]}
      {...storyblokEditable(blok)}
      flexDir="column"
      alignItems="center"
    >
      <Grid
        gridTemplateColumns={[
          "repeat(13, minmax(0, 1fr))",
          "repeat(26, minmax(0, 1fr))",
        ]}
        gap={3}
        mt={10}
        w={"100%"}
      >
        {alphabet.length !== 0 &&
          alphabet.map((letter) => (
            <Text
              key={letter}
              fontWeight="bold"
              color={letterHasItems.includes(letter) ? "brand.400" : "grey"}
              cursor={letterHasItems.includes(letter) ? "pointer" : "default"}
              onClick={() => {
                if (letterHasItems.includes(letter)) {
                  setFilterBy(letter);
                }
              }}
            >
              {letter.toUpperCase()}
            </Text>
          ))}
      </Grid>
      <Grid
        gridTemplateColumns={[
          "repeat(2, minmax(0, 1fr))",
          "repeat(3, minmax(0, 1fr))",
        ]}
        gap={3}
        my={10}
        justifyContent="flex-start"
        alignItems="flex-start"
        w="100%"
      >
        {worries
          .filter((item) => {
            if (filterBy !== null && item.name[0].toLowerCase() !== filterBy) {
              return;
            } else {
              return item;
            }
          })
          .map((item, index) => {
            if (index >= gridCountLimit) {
              return;
            }
            return (
              <Link
                prefetch={false}
                key={item.slug}
                href={`therapy/${item.slug}`}
              >
                <Flex
                  borderWidth={1}
                  borderColor="brand.400"
                  borderRadius={10}
                  p={4}
                  h={{ base: 190, md: 175 }}
                  overflow="hidden"
                  flexDir="column"
                >
                  <Text
                    textStyle="h5"
                    fontWeight="bold"
                    mb={2}
                    color={"brand.400"}
                  >
                    {item.name}
                  </Text>
                  <Text textOverflow="ellipsis" noOfLines={4} color={"black"}>
                    {item.content.summary}
                  </Text>
                </Flex>
              </Link>
            );
          })}
      </Grid>
    </Flex>
  );
};

export default WhatsWorryingYouBlok;
